module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/1-cf7d350508f7170cc7b823923315a8c2.jpg";